import { ATTACHMENT_PREFIX_MAP } from 'Constants';

/**
 * @param {object} attachment
 */
export function getAttachmentTitle(attachment) {
    return `MA${attachment.submission_id}${ATTACHMENT_PREFIX_MAP[attachment.type]}${attachment.version}_${attachment.file.file_name}`;
}



// WEBPACK FOOTER //
// ./src/utils/getAttachmentTitle.js